/**
 * Configuración general de la tabla
 */
export interface TableConfig {
  /** Habilitar búsqueda global */
  searchable?: boolean;
  
  /** Placeholder del input de búsqueda */
  searchPlaceholder?: string;
  
  /** Habilitar paginación */
  pageable?: boolean;
  
  /** Tamaño de página por defecto */
  defaultPageSize?: number;
  
  /** Opciones de tamaño de página */
  pageSizeOptions?: number[];
  
  /** Mostrar botones primera/última página */
  showFirstLastButtons?: boolean;
  
  /** Mensaje cuando no hay datos */
  emptyMessage?: string;
  
  /** Icono para estado vacío */
  emptyIcon?: string;
  
  /** Icono lucide angulat */
  emptyLucideIcon?: any;

  /** Mensaje secundario para estado vacío */
  emptySubMessage?: string;
  
  /** Mensaje durante carga */
  loadingMessage?: string;
  
  /** Diámetro del spinner de carga */
  spinnerDiameter?: number;
  
  /** Habilitar hover en las filas */
  rowHoverEffect?: boolean;
  
  /** Clase CSS para el hover de las filas */
  rowHoverClass?: string;
  
  /** Header fijo (sticky) */
  stickyHeader?: boolean;
  
  /** Mostrar contador de resultados */
  showResultsCount?: boolean;
  
  /** Texto singular para contador */
  resultsSingular?: string;
  
  /** Texto plural para contador */
  resultsPlural?: string;
  
  /** Altura máxima del contenedor de la tabla (ej: '400px', '50vh') */
  maxHeight?: string;
  
  /** Habilitar carga infinita al hacer scroll */
  infiniteScroll?: boolean;
  
  /** Distancia en px desde el fondo para disparar loadMore */
  scrollThreshold?: number;
  
  /** Habilitar selección múltiple con checkboxes */
  multiSelect?: boolean;
  
  /** Texto del tooltip para checkbox select all */
  selectAllTooltip?: string;
  
  /** Texto del tooltip para checkbox individual */
  selectTooltip?: string;
  
  /** Habilitar paginación del servidor */
  serverSidePagination?: boolean;
  
  /** Total de elementos en el servidor */
  totalServerItems?: number;

  /** Mostrar header de columna acciones */
  showActionsColumnHeader?: boolean;

  /** Usar menú compacto para acciones (muestra un solo botón que despliega las acciones) */
  useCompactActions?: boolean;
}

/**
 * Configuración por defecto
 */
export const DEFAULT_TABLE_CONFIG: TableConfig = {
  searchable: true,
  searchPlaceholder: 'Buscar...',
  pageable: true,
  defaultPageSize: 10,
  pageSizeOptions: [5, 10, 25, 50, 100],
  showFirstLastButtons: true,
  emptyMessage: 'No hay datos para mostrar',
  emptyIcon: 'inbox',
  emptySubMessage: '',
  loadingMessage: 'Cargando datos...',
  spinnerDiameter: 50,
  rowHoverEffect: true,
  rowHoverClass: 'hover:bg-light-bg-tertiary dark:hover:bg-dark-bg-tertiary transition-colors',
  stickyHeader: false,
  showResultsCount: false,
  resultsSingular: 'registro',
  resultsPlural: 'registros',
  maxHeight: undefined,
  infiniteScroll: false,
  scrollThreshold: 100,
  multiSelect: false,
  selectAllTooltip: 'Seleccionar todo',
  selectTooltip: 'Seleccionar fila',
  serverSidePagination: false,
  showActionsColumnHeader: true,
  useCompactActions: false,
};
